/**
 * APSelectMenuItem Component
 *
 * Individual menu item component for the APSelect dropdown.
 * Handles selection states, keyboard navigation, and accessibility.
 */

import React from 'react';

import APIconAstropay from '@shared/components/atoms/media/icon-ap';

import type { IAPSelectMenuItemProps } from './types';

// Check icon component for selected items using APIconAstropay
const CheckIcon = () => <APIconAstropay icon="check_line" size={16} color="currentColor" />;

export const APSelectMenuItem: React.FC<IAPSelectMenuItemProps> = ({
  option,
  isSelected,
  size: _size,
  onClick,
}) => {
  const itemClasses = [
    'apds-select__option',
    isSelected && 'apds-select__option--selected',
    option.disabled && 'apds-select__option--disabled',
  ]
    .filter(Boolean)
    .join(' ');

  const handleClick = () => {
    if (!option.disabled) {
      onClick();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={itemClasses}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="option"
      aria-selected={isSelected}
      tabIndex={option.disabled ? -1 : 0}
    >
      {isSelected && <CheckIcon />}
      <span className="apds-select__option-label">{option.label}</span>
    </div>
  );
};

export default APSelectMenuItem;
